var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000148773 19.9993L-0.000148249 15.9993L3.99979 15.9993L3.99979 19.9993L-0.000148773 19.9993Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 19.9993L35.9999 15.9993L39.9998 15.9993L39.9998 19.9993L35.9999 19.9993Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44453 5.27173L7.27292 2.44334L10.1013 5.27173L7.27291 8.10011L4.44453 5.27173Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8979 30.7273L32.7263 27.8989L35.5547 30.7273L32.7263 33.5557L29.8979 30.7273Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5567 5.27173L32.7284 2.44334L29.9 5.27173L32.7284 8.10011L35.5567 5.27173Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1017 30.7273L7.27327 27.8989L4.44489 30.7273L7.27327 33.5557L10.1017 30.7273Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0L21.9999 6.99372e-07L21.9999 3.99994L18 3.99994L18 0Z",
    fill: "#62CE23"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_1_793",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5987 31.6156C25.5987 30.612 26.193 29.7182 27.0411 29.1816C30.5754 26.9452 32.9134 23.0626 32.9134 18.6474C32.9134 11.7176 27.1539 6.09985 20.0491 6.09985C12.9444 6.09985 7.18491 11.7176 7.18491 18.6474C7.18491 23.1041 9.56706 27.0182 13.1572 29.2442C14.0044 29.7696 14.5989 30.656 14.5989 31.6529C14.5989 33.0594 15.7391 34.1996 17.1456 34.1996H23.0147C24.4418 34.1996 25.5987 33.0427 25.5987 31.6156Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 29.2442L15.265 25.8447L13.1572 29.2442ZM27.0411 29.1816L29.1799 32.5617L27.0411 29.1816ZM28.9134 18.6474C28.9134 21.6051 27.3527 24.2509 24.9023 25.8015L29.1799 32.5617C33.798 29.6395 36.9133 24.5202 36.9133 18.6474H28.9134ZM20.0491 10.0998C25.0393 10.0998 28.9134 14.0201 28.9134 18.6474H36.9133C36.9133 9.41509 29.2684 2.09991 20.0491 2.09991V10.0998ZM11.1849 18.6474C11.1849 14.0201 15.059 10.0998 20.0491 10.0998V2.09991C10.8299 2.09991 3.18497 9.41509 3.18497 18.6474H11.1849ZM15.265 25.8447C12.7751 24.3008 11.1849 21.6325 11.1849 18.6474H3.18497C3.18497 24.5757 6.35902 29.7355 11.0493 32.6437L15.265 25.8447ZM23.0147 30.1997H17.1456V38.1996H23.0147V30.1997ZM10.5989 31.6529C10.5989 35.2685 13.53 38.1996 17.1456 38.1996V30.1997C17.9482 30.1997 18.5988 30.8503 18.5988 31.6529H10.5989ZM11.0493 32.6437C10.982 32.6019 10.8851 32.5233 10.793 32.3744C10.6953 32.2161 10.5989 31.9665 10.5989 31.6529H18.5988C18.5988 29.0048 17.0424 26.9468 15.265 25.8447L11.0493 32.6437ZM23.0147 38.1996C26.6509 38.1996 29.5986 35.2518 29.5986 31.6156H21.5988C21.5988 30.8336 22.2327 30.1997 23.0147 30.1997V38.1996ZM24.9023 25.8015C23.1413 26.9158 21.5988 28.9731 21.5988 31.6156H29.5986C29.5986 31.9201 29.5058 32.1608 29.4136 32.3115C29.327 32.4529 29.2378 32.525 29.1799 32.5617L24.9023 25.8015Z",
    fill: "#0D1580",
    mask: "url(#path-8-inside-1_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 32.3992H23.5996V34.2991C23.5996 36.2321 22.0327 37.7991 20.0997 37.7991V37.7991C18.1667 37.7991 16.5998 36.2321 16.5998 34.2991V32.3992Z",
    stroke: "#0D1580",
    strokeWidth: 3.99994
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsight);
export default __webpack_public_path__ + "static/media/icon-insight.70c47e99fd24765cef06a1d69d5bb7cb.svg";
export { ForwardRef as ReactComponent };